<div class="email-suggest-panel mat-elevation-z4">
  <div
    *ngFor="let item of suggestions; let i = index"
    class="email-suggest-item"
    [class.active]="i === activeIndex"
    (mousedown)="onSelect($event, item)"
  >
    <mat-icon class="email-icon">email</mat-icon>
    <span class="email-text">{{ item }}</span>
    <mat-icon
      class="delete-icon"
      (mousedown)="onDelete($event, item)"
      title="Remove suggestion"
    >
      close
    </mat-icon>
  </div>
</div>
